import { filterImagesByProduct } from "../../../helpers/product";

type Image = { id: number };

type Examination = {
  images: Record<string, Image>;
};

type EncodedImages = Record<number, string | undefined>;

export type LightboxImage = { id: number; url: string };

/**
 * Derives the Lightbox navigation list from the paginated case collection and
 * the per-image data URIs loaded by EncodedImage. Keeping this as a derived
 * value (vs. a data field populated in a watcher) ensures cases appended via
 * "Load more" are included — a shallow watcher on `collection` does not fire
 * when the array is mutated in place.
 */
export function buildLightboxImages(
  collection: ReadonlyArray<Examination>,
  encodedImages: EncodedImages,
  productType: number,
): LightboxImage[] {
  return collection.flatMap((examination) =>
    Object.values(filterImagesByProduct(examination.images, productType)).map(
      (image: Image) => ({
        id: image.id,
        url: encodedImages[image.id] ?? "",
      }),
    ),
  );
}
